import { AxiosInstance } from 'axios'

export function setupAutoUpdateToken(axios: AxiosInstance) {
  const wait = (ms: number) => new Promise(res => setTimeout(res, ms))
  let retryCount = 0
  axios.interceptors.response.use(
    function (res) {
      return res
    },
    async function axiosRetryInterceptor(err) {
      if (err.config && err.response && err.response.status === 401) {
        if (window.getPostmateHandshake()) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          window.getPostmateHandshake().then(parent => {
            parent.emit('refresh-token')
          })
        }

        if (retryCount >= 5) {
          return Promise.reject(err)
        }
        await wait(2 ** retryCount * 10) // exponential back off time. -> wait for token
        retryCount++
        return axios.request(err.config)
      }
      return Promise.reject(err)
    }
  )
}
